<template>
    <div class="business">
        <Header></Header>
        <div class="business_container business_container_bg1">
            <div class="main_content">
                <div class="business_title">电商行业解决方案</div>
                <div class="business-bg1-box">
                    <div class="business-bg1-box-title">行业背景：</div>
                    <div class="business-bg1-box-text">
                        随着电商的蓬勃发展，中国电商市场规模已经连续多年保持两位数的增长。2024年，中国网络零售额达到15.67万亿元，快递业务量突破1200亿件。在这种高速增长背景下，物流效率成为电商企业核心竞争力之一。电子面单作为物流信息数字化的关键载体，其打印效率、准确性和稳定性直接影响着电商企业的订单处理能力和客户体验。
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_write">
            <div class="main_content">
                <div class="business-tabs">
                    <div class="business-tab" v-for="(tab, index) in tabList" :key="tab.title + index"
                         :class="{active: activeTabIndex === index}" @click="activeTabIndex = index">
                        <img v-if="index === 0" src="../images/icon1.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon2.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon3.png" alt="icon">
                        {{ tab.tabName }}
                    </div>
                </div>
                <div class="business_title">
                    {{ tabList[activeTabIndex].title }}
                </div>
                <div class="business_subtitle"> {{ tabList[activeTabIndex].subtitle }}</div>
                <div class="business-block" v-if="activeTabIndex === 0">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">面单规格复杂</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">多平台运营导致面单格式不统一，<br/>频繁更换耗材；
                            </div>
                            <img class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                        </div>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">人工效率低</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">人工录入易出错，导致物流延误和<br/>客户投诉；</div>
                            <img class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                        </div>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">机器使用复杂</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">多平台运营导致面单格式不统一，<br/>频繁更换耗材；
                            </div>
                            <img class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                        </div>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">打印组件安装复杂</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">多平台运营导致面单格式不统一，<br/>频繁更换耗材；
                            </div>
                            <img class="business-block-item-img" src="../images/icon7.png" alt="img"/>
                        </div>
                    </div>
                </div>
                <div class="business-block2" v-else-if="activeTabIndex === 1">
                    <div class="business-block-item1"></div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">打印速度慢</div>
                        <div class="business-block-item-text">传统打印机速度慢，无法满足<br/>大促期间爆发式订单增长需求
                        </div>
                        <img class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">打印问题多</div>
                        <div class="business-block-item-text">
                            传统打印机不稳定，大批量打<br/>印时会出现丢单和重复打印，<br/>导致客诉或多发货损失
                        </div>
                        <img class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">仓库环境复杂</div>
                        <div class="business-block-item-text">部分仓库环境恶劣，设备容易<br/>出故障，导致业务停摆
                        </div>
                        <img class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
                <div class="business-block2" v-else-if="activeTabIndex === 2">
                    <div class="business-block-item1 business-block-item2"></div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">管理困难</div>
                        <div class="business-block-item-text">多仓库、多网点情况下难以管<br/>控和分单</div>
                        <img class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">异地打印难满足</div>
                        <div class="business-block-item-text">需要异地打单，普通打印机无法<br/>满足</div>
                        <img class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                    </div>
                    <div class="business-block-item">
                        <div class="business-block-item-title">不同语言不同打印机</div>
                        <div class="business-block-item-text">部分仓库环境恶劣，设备容易<br/>出故障，导致业务停摆</div>
                        <img class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">解决方案</div>
                <div class="business_subtitle">{{ tabList[activeTabIndex].solution }}</div>
                <div class="business-solution-content" v-if="activeTabIndex === 0">
                    <img class="business-solution-content-printer-img" src="../ECommerce/images/printer1.png" alt="printer">
                    <div class="business-solution-content-printer">
                        <div class="business-solution-content-printer-title">
                            <span class="other-color">KM-202</span> 无纸仓面单打印机
                        </div>
                        <div class="business-solution-content-printer-subtitle">
                            无纸仓设计不占空间，纸张自动进退更环保
                        </div>
                        <div class="business-solution-content-printer-list">
                            打印速度：150mm/s<br/>
                            分辨率：203dpi<br/>
                            支持纸张宽度：max104<br/>
                            接口：usb<br/>
                            日均打印量：<br/>
                            适用场景：快递面单打印
                        </div>
                    </div>
                </div>
                <div class="business-solution-content" v-else-if="activeTabIndex === 1">
                    <img class="business-solution-content-printer-img" src="../ECommerce/images/printer1.png" alt="printer">
                    <div class="business-solution-content-printer">
                        <div class="business-solution-content-printer-title">
                            <span class="other-color">KM-G41</span> 高速工业打印机
                        </div>
                        <div class="business-solution-content-printer-subtitle">
                            无纸仓设计不占空间，纸张自动进退更环保
                        </div>
                        <div class="business-solution-content-printer-list">
                            打印速度：150mm/s<br/>
                            分辨率：203dpi<br/>
                            支持纸张宽度：max108<br/>
                            接口：usb<br/>
                            日均打印量：<br/>
                            适用场景：快递面单打印
                        </div>
                    </div>
                </div>
                <template v-else-if="activeTabIndex === 2">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="../ECommerce/images/printer1.png" alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-G41</span> KM-202MGC菜鸟云打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：180mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：max80mm<br/>
                                接口：usb
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-202MGD</span> 拼多多云打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：180mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：max80mm<br/>
                                接口：usb
                            </div>
                        </div>
                        <img class="business-solution-content-printer-img" src="../ECommerce/images/printer1.png" alt="printer">
                    </div>
                </template>
                <div class="business-solution-content">
                    <img v-show="activeTabIndex === 2" class="business-solution-content-gj-img"
                         src="../images/gj-bg.png" alt="printer">
                    <div class="business-solution-content-gj">
                        <div class="business-solution-content-gj-title">
                            <img src="../images/gj.png" alt="gj">
                            番茄打印管家
                        </div>
                        <div class="business-solution-content-gj-subtitle">
                            驱动安装自动化 支持多品牌机器打印
                        </div>
                        <div class="business-solution-content-gj-list">
                            <div class="business-solution-content-gj-list-item">
                                <div class="business-solution-content-gj-list-item-title">驱动自动安装</div>
                                <div class="business-solution-content-gj-list-item-text">
                                    打印机开机并连接usb数据线，<br/>
                                    驱动自动安装。
                                </div>
                            </div>
                            <div class="business-solution-content-gj-list-item">
                                <div class="business-solution-content-gj-list-item-title">支持多型号、品牌驱动安装</div>
                                <div class="business-solution-content-gj-list-item-text">
                                    支持其他品牌机器安装驱动；<br/>
                                    多型号无需重复下载管家。
                                </div>
                            </div>
                            <div class="business-solution-content-gj-list-item">
                                <div class="business-solution-content-gj-list-item-title">打印机设置可视化</div>
                                <div class="business-solution-content-gj-list-item-text">
                                    打印机开机并连接usb数据线，<br/>
                                    驱动自动安装。
                                </div>
                            </div>
                            <div class="business-solution-content-gj-list-item">
                                <div class="business-solution-content-gj-list-item-title">打印诊断</div>
                                <div class="business-solution-content-gj-list-item-text">
                                    自动化检测并修复非打印机本身<br/>
                                    导致的打印问题。
                                </div>
                            </div>
                        </div>
                    </div>
                    <img v-show="activeTabIndex !== 2" class="business-solution-content-gj-img"
                         src="../images/gj-bg.png" alt="printer">
                </div>
            </div>
        </div>
        <div class="business_container business_container_white">
            <div class="main_content">
                <div class="business_title">方案优势</div>
                <div class="business-good">
                    <div class="business-good-item">
                        <img src="../images/icon8.png" alt="icon">
                        <div class="business-good-item-title">效率提升</div>
                        <div class="business-good-item-text">打印速度最快可达300mm/s，处理能力提升2～3倍</div>
                    </div>
                    <div class="business-good-item">
                        <img src="../images/icon9.png" alt="icon">
                        <div class="business-good-item-title">稳定可靠</div>
                        <div class="business-good-item-text">打印机可以连续24小时稳定工作，不丢单、不重打，减少损失</div>
                    </div>
                    <div class="business-good-item">
                        <img src="../images/icon10.png" alt="icon">
                        <div class="business-good-item-title">不挑环境</div>
                        <div class="business-good-item-text">打印机更加耐用，对使用环境不挑剔，故障率极低</div>
                    </div>
                    <div class="business-good-item">
                        <img src="../images/icon11.png" alt="icon">
                        <div class="business-good-item-title">智能管理</div>
                        <div class="business-good-item-text">
                            配合番茄打印管家软件使用，实时监控设备状态，预测性维护，简化操作
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">行业合作案例</div>
                <div class="business-collaborative">
                    <template v-if="activeTabIndex === 0">
                    </template>
                    <template v-else-if="activeTabIndex === 1">
                    </template>
                    <template v-else-if="activeTabIndex === 2">
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../Header.vue';

export default {
    name: "LargeStorage",
    components: {Header},
    data() {
        return {
            activeTabIndex: 0,
            tabList: [
                {
                    tabName: '中小型电商企业',
                    title: '中小型电商企业',
                    subtitle: '多平台运营，需要兼容各电商平台面单格式及打单软件',
                    solution: '快麦标准面单打印机搭配番茄打印管家软件，软硬件结合让打印更智能'
                },
                {
                    tabName: '大型电商仓库',
                    title: '大型电商仓库',
                    subtitle: '日均处理数万至数十万订单，需要高速、稳定的批量打印',
                    solution: '部署工业级电子面单专用打印机，搭配番茄打印管家软件，实现大批量订单稳定打印'
                },
                {
                    tabName: '直播类电商',
                    title: '直播类电商 (跨境电商、多仓电商）',
                    subtitle: '边直播边打单，多仓库发货，需要统一管理，或需要支持多种语言，多格式打单',
                    solution: '部署快麦云面单打印机，搭配番茄打印管家软件，实现异地同步打单'
                },
            ]
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../business.scss";
</style>
